import { ApiCore } from './utilities/core'


export const zendeskHistoryAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        url: `api/${tenantSlug}/zendesk/search-history`
    })
};